import { useState, useEffect} from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PopUp from '../Popup/logoutPopup';
import { useAppContext } from '../Lib/contextLib';
import { getRedoModalMessage } from '../services/RedoService';
import '../routes/Redo/RedoPage.scss';
import './UnitPage.scss';
import UnitWorld from './components/UnitWorld';
import wafLogo from './WeAreFriends_Logo.png';


/**
 * Displays four worlds that can be clicked on to enter a unit.
 * @returns The HtML code for the unit page.
 */
const UnitPage = () => {
  // Initialize variables to be used later.
  
  const { userHasAuthenticated } = useAppContext();
  const { module5 } = useSelector((state) => state.module5, shallowEqual);
  const { module10 } = useSelector((state) => state.module10, shallowEqual);
  const { module15 } = useSelector((state) => state.module15, shallowEqual);
  const { module20 } = useSelector((state) => state.module20, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const { pendingRedos } = useSelector((state) => state.redoReducer, shallowEqual);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [freePlay, setFreePlay] = useState(false);
  const [prompt, setPrompt] = useState('');
  const [showRedoModal, setShowRedoModal] = useState(false);

  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
  const dispatch = useDispatch();

  const Unit1World = generateImageUrl('images/Images/Worlds/WorldMap_Small_Unit1.png');
  const Unit2World = generateImageUrl('images/Images/Worlds/WorldMap_Small_Unit2.png');
  const Unit3World = generateImageUrl('images/Images/Worlds/WorldMap_Small_Unit3.png');
  const Unit4World = generateImageUrl('images/Images/Worlds/WorldMap_Small_Unit4.png');
  const LogoutIcon = generateImageUrl('images/Images/Logout.png');

  // Toggle individual popups (such as the logout confirmation)
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const displayName = (name) => {
    switch (name) {
        case "Greet":
            return "World 2 Greet";
        case "Answer":
            return "World 2 Answer";
        case "Ask":
            return "World 2 Ask";
        case "Respond":
            return "World 2 Respond";
        case "Close":
            return "World 2 Close";
        case "Feelings":
            return "World 3 Feelings";
        case "UnderstandFeelings":
            return "World 3 Understand Feelings";
        case "ChangeFeelings":
            return "World 3 Change Feelings";
        case "Solutions":
            return "World 3 Creating Solutiosn";
        case "ActiveListening":
            return "World 3 Active Listening";
        case "Manners":
            return "World 4 Manners"
        case "FriendsBullies":
            return "World 4 Friends/Bullying";
        case "ResolveConflict":
            return "World 4 Resolve Conflict";
        case "SelfAdvocacy":
            return "World 4 Self Advocacy";
        case "Caring":
            return "World 4 Caring";
        case "Level1":
            return "Free Play Level 1";
        case "Level2":
            return "Free Play Level 2";
        default:
            return name;
    }
  }

  useEffect(() => {
    if (module20.day_completed === 9) {
      setFreePlay(true);
    }
    if(login.receivedCoin){
      let totalCoins = login.receivedCoin.reduce((sum, row) => sum + row.coin, 0);
      let location = login.receivedCoin[0]?.location; // Take location from the first row
      setPrompt(`You've got ${totalCoins} coins from your friends! Check them out in ${displayName(location)}.`);   
    }
    if (pendingRedos.length > 0) {
      setShowRedoModal(true);
    }
  }, []);

  //check Student' grade and choose path
  const checkGrade = (unit) =>{
    if (unit === 1){
      switch (login.grade) {
        case 'Preschool':
          return true
        case 'Kindergarten':
          return true
        case '1st Grade':
          return true
        case '2nd Grade':
          return false
        case '3rd Grade':
          return false
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return true
      }
    }
    else if (unit === 2){
      switch (login.grade) {
        case 'Preschool':
          return module5.day_completed === 9 ? true : false
        case 'Kindergarten':
          return module5.day_completed === 9 ? true : false
        case '1st Grade':
          return module5.day_completed >= 5 ? true : false
        case '2nd Grade':
          return true
        case '3rd Grade':
          return false
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return module5.day_completed === 9 ? true : false
      }
    }
    else if (unit === 3){
      switch (login.grade) {
        case 'Preschool':
          return module10.day_completed === 9 ? true : false
        case 'Kindergarten':
          return module10.day_completed === 9 ? true : false
        case '1st Grade':
          return module10.day_completed === 9 ? true : false
        case '2nd Grade':
          return module10.day_completed >= 4 ? true : false
        case '3rd Grade':
          return true
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return module10.day_completed === 9 ? true : false
      }
    }
    else if (unit === 4){
      switch (login.grade) {
        case 'Preschool':
          return false
        case 'Kindergarten':
          return module15.day_completed === 9 ? true : false
        case '1st Grade':
          return module15.day_completed === 9 ? true : false
        case '2nd Grade':
          return module15.day_completed === 9 ? true : false
        case '3rd Grade':
          return module15.day_completed === 9 ? true : false
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return module15.day_completed === 9 ? true : false
      }
    }

  }

  const navigateFreeplay = (level) =>{
    switch(level){
      case 'Level1':
        navigate('/freeplay')
        break;
      case 'Level2':
        navigate('/freeplay_2')
        break;
      default:
        navigate('/freeplay')
        break;
    }
  }

  // The HTML code for the units page.
  return (
    <div className='units-page'>
      <header>
        <img src={LogoutIcon} alt='Logout Icon button' onClick={togglePopup} />
          <img className='logo_image' src={wafLogo} alt='' />
      </header>
      <div className='units-page__worlds'>
        <UnitWorld
          unlocked={checkGrade(1)}
          worldImage={Unit1World}
          path='/unit1'
          title='Nonverbal Communication Skills'
        />

        <UnitWorld
          unlocked={checkGrade(2)}
          worldImage={Unit2World}
          path='/unit2'
          title='Verbal Communication Skills'
        />

        <UnitWorld
          unlocked={checkGrade(3)}
          worldImage={Unit3World}
          path='/unit3'
          title='Understanding Emotions'
        />

        <UnitWorld
          unlocked={checkGrade(4)}
          worldImage={Unit4World}
          path='/unit4'
          title='Behavioral & Social Awareness Skills'
        />
      </div>
      <button
        className={`freePlayBtn ${(!freePlay && login.grade !== "Free Play" && login.grade !== "Teacher Account")? 'disabled' : ''}`}
        onClick={() => (freePlay || login.grade === "Free Play" || login.grade === "Teacher Account") && navigateFreeplay(login.current_module)}
        disabled={(!freePlay && login.grade !== "Free Play" && login.grade !== "Teacher Account")}
      >
        {(!freePlay && login.grade !== "Free Play" && login.grade !== "Teacher Account") && <span className="lock-icon">Free🔒Play</span>}
        {(freePlay || login.grade === "Free Play" || login.grade === "Teacher Account") && <span>Free Play</span>}
      </button>
      {showRedoModal && (
        <PopUp
          content={
            <>
              <p className='redo-modal-message'>
                {getRedoModalMessage(pendingRedos.length)}
              </p>
              <button
                className='redo-modal-button'
                onClick={() => {
                  setShowRedoModal(false);
                  navigate('/redo');
                }}
              >
                Okay
              </button>
            </>
          }
        />
      )}
      {login.receivedCoin && !showRedoModal && <PopUp
        content={
          <>
            <b id="title">
                {prompt}
              <br />
            </b>
            <button
              id="logoutButton2"
              className="logoutButton"
              onClick={() => {
                dispatch({ type: 'SET_RECEIVEDCOIN', payload: null });
              }}
            >
              <b id="title">
                OKAY
              </b>
            </button>
          </>
        }
      />}
      {isOpen && (
        <PopUp
          content={
            <>
              <b id='title'>
                Are you sure you want to leave?
                <br />
              </b>
              <button
                id='logoutButton1'
                className='logoutButton'
                onClick={() => {
                  navigate('/');
                  userHasAuthenticated(false);
                  localStorage.setItem('token', 'false');
                }}
              >
                YES
              </button>
              <button
                id='logoutButton2'
                className='logoutButton'
                onClick={togglePopup}
              >
                NO
              </button>
            </>
          }
          handleClose={togglePopup}
        />
      )}
    </div>
  );
};
export default UnitPage;
